<template>
  <div class="page-avsnewsletter header-margin">
    <h2>APOVERLAG-Newsletter Archiv</h2>
    <iframe id="avs-newsletter-iframe" :src="iframe.src" class="avs-newsletter-iframe" @load="load" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframe: {
        src: '/avs-newsletter-iframe.html',
        loaded: false,
      },
    }
  },
  methods: {
    load() {
      this.iframe.loaded = true
    },
  },
}
</script>

<style lang="scss">
@import '@/css/import/vars.scss';

.page-avsnewsletter {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: $content-max-width;
  margin: 0 auto;
  padding: 30px 15px 0 15px;
  position: relative;

  h2 {
    font-variation-settings: 'wght' 400;
    color: $color-headline;
    font-size: 36px;
    margin-bottom: 2rem;
    flex-basis: 100%;
    text-align: center;

    @media (min-width: $screen-width-1023) {
      font-size: 42px;
      margin-bottom: 4rem;
    }
  }

  .avs-newsletter-iframe {
    width: 100%;
    height: 1000px;
    border: none;
    outline: none;
  }
}
</style>
